import Assessment from "@/assets/images/icons/assessment.svg";
import ChevronDown from "@/assets/images/icons/chevron-down.svg";
import ChevronRight from "@/assets/images/icons/chevron-right.svg";
import Currency from "@/assets/images/icons/currency.svg";
import DatabaseEncryption from "@/assets/images/icons/database-encryption.svg";
import Dot from "@/assets/images/icons/dot.svg";
import Fintech from "@/assets/images/icons/fintech.svg";
import Government from "@/assets/images/icons/government.svg";
import Healthcare from "@/assets/images/icons/healthcare.svg";
import Manufacturing from "@/assets/images/icons/manufacturing.svg";
import Puzzle from "@/assets/images/icons/puzzle.svg";
import Li from "@/assets/images/icons/li.svg";
import Lock from "@/assets/images/icons/lock.svg";
import OldMission from "@/assets/images/icons/mission.svg";
import RightArrow from "@/assets/images/icons/right-arrow.svg";
import Rocket from "@/assets/images/icons/rocket.svg";
import SearchBook from "@/assets/images/icons/search-book.svg";
import Shield from "@/assets/images/icons/shield.svg";
import Target from "@/assets/images/icons/target.svg";
import TaskList from "@/assets/images/icons/task-list.svg";
import PdfFile from "@/assets/images/icons/pdf-file.svg";
import TextFile from "@/assets/images/icons/text-file.svg";
import ExcelSheet from "@/assets/images/icons/excel-file.svg";
import Flag from "@/assets/images/icons/flag.svg";
import CodeEditor from "@/assets/images/icons/code_editor.svg";
import Key from "@/assets/images/icons/key.svg";
import Community from "@/assets/images/icons/community.svg";
import HandShake from "@/assets/images/icons/hand-shake.svg";
import Policies from "@/assets/images/icons/policies.svg";
import Risk from "@/assets/images/icons/risk.svg";
import AddFolder from "@/assets/images/icons/add_folder.svg";
import Clock from "@/assets/images/icons/clock.svg";
import MailBlue from "@/assets/images/icons/mail-blue.svg";
import MailYellow from "@/assets/images/icons/mail-yellow.svg";
import TargetCursor from "@/assets/images/icons/target-cursor.svg";
import Location from "@/assets/images/icons/location.svg";
import CallYellow from "@/assets/images/icons/call-yellow.svg";
import CallBlue from "@/assets/images/icons/call-blue.svg";
import Person from "@/assets/images/icons/person.svg";
import postAddress from "@/assets/images/icons/post-address.svg";
import workInquiries from "@/assets/images/icons/work-inquiries.svg";
import support from "@/assets/images/icons/support.svg";
import officeHours from "@/assets/images/icons/office-hours.svg";
import bugVirus from "@/assets/images/icons/bug-virus.svg";
import cloud from "@/assets/images/icons/cloud.svg";
import desktopCode from "@/assets/images/icons/desktop-code.svg";
import phone from "@/assets/images/icons/phone.svg";
import insurance from "@/assets/images/icons/insurance.svg";
import script from "@/assets/images/icons/script.svg";
import Twitter from "@/assets/images/icons/twitter.svg";
import Linkedin from "@/assets/images/icons/linkedin.svg";
import Whatsapp from "@/assets/images/icons/WhatsApp.svg";
import Teams from "@/assets/images/icons/teams.svg";
import Slack from "@/assets/images/icons/slack.svg";
import Gmail from "@/assets/images/icons/gmail.svg";
import CaseStudyIcon from "@/assets/images/icons/case-study-icon.svg";
import Excited from "@/assets/images/icons/excited.svg";
import Break from "@/assets/images/icons/break.svg";
import Communication from "@/assets/images/icons/communication.svg";
import AlarmClock from "@/assets/images/icons/alaram-clock.svg";
import LabAccess from "@/assets/images/icons/lab-computer.svg";
import Training from "@/assets/images/icons/practical-trainee.svg";
import Documentation from "@/assets/images/icons/content-folder.svg";
import ProfessionalTrainers from "@/assets/images/icons/trainers.svg";
import QualityTraining from "@/assets/images/icons/pen-book.svg";
import UseCase from "@/assets/images/icons/use-case.svg";
import SampleReports from "@/assets/images/icons/sample-reports.svg";
import EBook from "@/assets/images/icons/ebook.svg";
import DataSheet from "@/assets/images/icons/datasheet.svg";

// ------------------------------- About Us -------------------------------
import ComplianceAndPrivacy from "@/assets/images/icons/about-us/compliance-and-privacy.svg";
import IncidentRespose from "@/assets/images/icons/about-us/incident-response.svg";
import Mission from "@/assets/images/icons/about-us/mission.svg";
import PentestManagement from "@/assets/images/icons/about-us/pentest-management.svg";
import Values from "@/assets/images/icons/about-us/values.svg";
import Vision from "@/assets/images/icons/about-us/vision.svg";

// ------------------------------- Culture and Team -------------------------------
import ClientChampion from "@/assets/images/icons/culture-and-team/client-champion.svg";
import EnergyBoosters from "@/assets/images/icons/culture-and-team/energy-boosters.svg";
import LifelongLearners from "@/assets/images/icons/culture-and-team/lifelong-learner.svg";
import MentalHealthMatters from "@/assets/images/icons/culture-and-team/mental-health-matters.svg";
import MondayBlues from "@/assets/images/icons/culture-and-team/monday-blues.svg";
import TakeBreaks from "@/assets/images/icons/culture-and-team/take-breaks.svg";
import TalkItOut from "@/assets/images/icons/culture-and-team/talk-it-out.svg";

// ------------------------------- Home page -------------------------------
import AiSecurity from "@/assets/images/icons/home-page/ai-security.svg";
import Compliance from "@/assets/images/icons/home-page/compliance.svg";
import EffectiveSecurityControls from "@/assets/images/icons/home-page/effective-security-controls.svg";
import IncreasedVigilance from "@/assets/images/icons/home-page/increased-vigilance.svg";
import ManagedServices from "@/assets/images/icons/home-page/managed-services.svg";
import PrivacyAssessment from "@/assets/images/icons/home-page/privacy-assessment.svg";
import ProactiveApproach from "@/assets/images/icons/home-page/proactive-approach.svg";
import Saas from "@/assets/images/icons/home-page/saas.svg";
import VulnerabilityManagement from "@/assets/images/icons/home-page/vulnerability-management.svg";

// ------------------------------- Resources -------------------------------
import AssetManagementCompany from "@/assets/images/icons/resources/asset-management-company.svg";
import DomesticLogisticFirm from "@/assets/images/icons/resources/domestic-logistics-firm.svg";
import ECommercePlatform from "@/assets/images/icons/resources/e-commerce-platform.svg";
import FintechBankingFirm from "@/assets/images/icons/resources/fintech-banking-firm.svg";
import HealthcareFirmsErpSoftware from "@/assets/images/icons/resources/healthcare-firms-erp-software.svg";
import LogisticShippingCompany from "@/assets/images/icons/resources/logistic-shipping-company.svg";
import MachineryManufacturingFirm from "@/assets/images/icons/resources/machinery-manufacturing-firm.svg";
import PharmaManufacturingFirm from "@/assets/images/icons/resources/pharma-manufacturing-firm.svg";
import SaasProduct from "@/assets/images/icons/resources/saas-product.svg";

// ------------------------------- Industry -------------------------------
// Fintech
import Apis from "@/assets/images/icons/industry/fintech/apis.svg";
import CustomerData from "@/assets/images/icons/industry/fintech/customer-data.svg";
import FinancialTransactions from "@/assets/images/icons/industry/fintech/financial-transactions.svg";
import PaymentSystems from "@/assets/images/icons/industry/fintech/payment-systems.svg";

// Healthcare
import Applications from "@/assets/images/icons/industry/healthcare/applications.svg";
import BillingSystems from "@/assets/images/icons/industry/healthcare/billing-systems.svg";
import EhrSystems from "@/assets/images/icons/industry/healthcare/ehr-systems.svg";
import MedicalDevices from "@/assets/images/icons/industry/healthcare/medical-devices.svg";
import VendorSelection from "@/assets/images/icons/industry/healthcare/vendor-selection.svg";

// Manufacturing
import IndustrialControlSystems from "@/assets/images/icons/industry/manufacturing/industrial-control-systems.svg";
import IotDevices from "@/assets/images/icons/industry/manufacturing/iot-devices.svg";
import ProductionData from "@/assets/images/icons/industry/manufacturing/production-data.svg";
import SupplyChain from "@/assets/images/icons/industry/manufacturing/supply-chain.svg";

// SaaS
import ApplicationIntegrity from "@/assets/images/icons/industry/saas/application-integrity.svg";
import RegulatoryCompliance from "@/assets/images/icons/industry/saas/regulatory-compliance.svg";

// ------------------------------- Services -------------------------------
// AI Security
import AdversarialAttackSimulation from "@/assets/images/icons/services/ai-security/adversarial-attack-simulation.svg";
import ContinuesMonitoring from "@/assets/images/icons/services/ai-security/continuous-monitoring.svg";
import DataGovernance from "@/assets/images/icons/services/ai-security/data-governance.svg";
import DataIntegrityTesting from "@/assets/images/icons/services/ai-security/data-integrity-testing.svg";
import ModelIntegrityAudits from "@/assets/images/icons/services/ai-security/model-integrity-audits.svg";
import ModelRobustnessEvaluation from "@/assets/images/icons/services/ai-security/model-robustness-evaluation.svg";

// Compliance
import AdaptiveSecurityMeasures from "@/assets/images/icons/services/compliance/adaptive-security-measures.svg";
import AdvancedPersistentThreat from "@/assets/images/icons/services/compliance/advanced-persistent-threat.svg";
import AdvancedSearchAlgorithms from "@/assets/images/icons/services/compliance/advanced-search-algorithms.svg";
import AdvancedThreatDetection from "@/assets/images/icons/services/compliance/advanced-threat-detection.svg";
import Applicability from "@/assets/images/icons/services/compliance/applicability.svg";
import AssessmentAndFeedback from "@/assets/images/icons/services/compliance/assessment-and-feedback.svg";
import AttackSurfaceMapping from "@/assets/images/icons/services/compliance/attack-surface-mapping.svg";
import AuditAndReporting from "@/assets/images/icons/services/compliance/audit-and-reporting.svg";
import AuditReadinessAndSupport from "@/assets/images/icons/services/compliance/audit-readiness-and-support.svg";
import AutomatedAndManualAssessments from "@/assets/images/icons/services/compliance/automated-and-manual-assessments.svg";
import AutomatedAndManualAssessmentsFirm from "@/assets/images/icons/services/compliance/automated-and-manual-assessments-firm.svg";
import AutomatedAuditTrails from "@/assets/images/icons/services/compliance/automated-audit-trails.svg";
import BaselineEstablishment from "@/assets/images/icons/services/compliance/baseline-establishment.svg";
import BusinessContinuityAndDisasterRecovery from "@/assets/images/icons/services/compliance/business-continuity-and-disaster-recovery.svg";
import CentralizedManagement from "@/assets/images/icons/services/compliance/centralized-management.svg";
import CloudInfrastructureSecurity from "@/assets/images/icons/services/compliance/cloud-infrastructure-security.svg";
import CohesiveSearchAndDiscover from "@/assets/images/icons/services/compliance/cohesive-search-and-discover.svg";
import ComplianceMapping from "@/assets/images/icons/services/compliance/compliance-mapping.svg";
import ComplianceUpdates from "@/assets/images/icons/services/compliance/compliance-updates.svg";
import ConfigurationAndDeployment from "@/assets/images/icons/services/compliance/configuration-and-deployment.svg";
import ConsentCaptureAndStore from "@/assets/images/icons/services/compliance/consent-capture-and-store.svg";
import CredentialMonitoring from "@/assets/images/icons/services/compliance/credential-monitoring.svg";
import CrossFunctionalCoordination from "@/assets/images/icons/services/compliance/cross-functional-coordination.svg";
import CustomizedIamPlan from "@/assets/images/icons/services/compliance/customized-iam-plan.svg";
import CustomizedTrainingPlan from "@/assets/images/icons/services/compliance/customized-training-plan.svg";
import CustomPolicyDrafting from "@/assets/images/icons/services/compliance/custom-policy-drafting.svg";
import DataAudits from "@/assets/images/icons/services/compliance/data-audits.svg";
import DataDeletionAndRetention from "@/assets/images/icons/services/compliance/data-deletion-and-retention.svg";
import DataEncryptionAndSecureCommunication from "@/assets/images/icons/services/compliance/data-encryption-and-secure-communication.svg";
import DataFlowMapping from "@/assets/images/icons/services/compliance/data-flow-mapping.svg";
import DataInsights from "@/assets/images/icons/services/compliance/data-insights.svg";
import DataLeakDetection from "@/assets/images/icons/services/compliance/data-leak-detection.svg";
import DataPrivacyImplementation from "@/assets/images/icons/services/compliance/data-privacy-implementation.svg";
import DataProtectionImpactAssessment from "@/assets/images/icons/services/compliance/data-protection-impact-assessment.svg";
import DefineScopeAndObjectives from "@/assets/images/icons/services/compliance/define-scope-and-objectives.svg";
import DrillExecution from "@/assets/images/icons/services/compliance/drill-execution.svg";
import DynamicUpdates from "@/assets/images/icons/services/compliance/dynamic-updates.svg";
import EnforceAccessControls from "@/assets/images/icons/services/compliance/enforce-access-controls.svg";
import EnhancedSecurity from "@/assets/images/icons/services/compliance/enhanced-security.svg";
import ExternalPenetrationTesting from "@/assets/images/icons/services/compliance/external-penetration-testing.svg";
import ExtractLineageInformation from "@/assets/images/icons/services/compliance/extract-lineage-information.svg";
import FirewallAndRouterConfigurationAudit from "@/assets/images/icons/services/compliance/firewall-and-router-configuration-audit.svg";
import FrameworkOptimization from "@/assets/images/icons/services/compliance/framework-optimization.svg";
import GapAssessment from "@/assets/images/icons/services/compliance/gap-assessment.svg";
import Gdpr from "@/assets/images/icons/services/compliance/gdpr.svg";
import Hippa from "@/assets/images/icons/services/compliance/hippa.svg";
import IdentifyUserAccess from "@/assets/images/icons/services/compliance/identify-user-access.svg";
import ImprovedUserExperience from "@/assets/images/icons/services/compliance/improved-user-experience.svg";
import InitialAssessment from "@/assets/images/icons/services/compliance/initial-assessment.svg";
import InitialVendorAssessment from "@/assets/images/icons/services/compliance/initial-vendor-assessment.svg";
import IntegrationOfDarkWebMonitoring from "@/assets/images/icons/services/compliance/integration-of-dark-web-monitoring.svg";
import IntegrationWithCloudSecuritySolution from "@/assets/images/icons/services/compliance/integration-with-cloud-security-solution.svg";
import IntegrationWithEmailSecuritySolution from "@/assets/images/icons/services/compliance/integration-with-email-security-solution.svg";
import InteractiveEngagement from "@/assets/images/icons/services/compliance/interactive-engagement.svg";
import InternalVulnerabilityAssessment from "@/assets/images/icons/services/compliance/internal-vulnerability-assessment.svg";
import Iso27799 from "@/assets/images/icons/services/compliance/iso-27799.svg";
import MitigatePrivacyRisk from "@/assets/images/icons/services/compliance/mitigate-privacy-risk.svg";
import MobileApplication from "@/assets/images/icons/services/compliance/mobile-application.svg";
import MonitorAccessChanges from "@/assets/images/icons/services/compliance/monitor-access-changes.svg";
import MultiJurisdictionalExpertise from "@/assets/images/icons/services/compliance/multi-jurisdictional-expertise.svg";
import MultiPlatformAcquisition from "@/assets/images/icons/services/compliance/multi-platform-acquisition.svg";
import OngoingManagement from "@/assets/images/icons/services/compliance/ongoing-management.svg";
import OngoingReview from "@/assets/images/icons/services/compliance/ongoing-review.svg";
import PatchManagement from "@/assets/images/icons/services/compliance/patch-management.svg";
import Pci from "@/assets/images/icons/services/compliance/pci.svg";
import PciDssComplianceReporting from "@/assets/images/icons/services/compliance/pci-dss-compliance-reporting.svg";
import PhishingSimulation from "@/assets/images/icons/services/compliance/phishing-simulation.svg";
import PlaybookDevelopment from "@/assets/images/icons/services/compliance/playbook-development.svg";
import PolicyAndProcedureReview from "@/assets/images/icons/services/compliance/policy-and-procedure-review.svg";
import PolicyDesign from "@/assets/images/icons/services/compliance/policy-design.svg";
import PolicyDevelopment from "@/assets/images/icons/services/compliance/policy-development.svg";
import PolicyTraining from "@/assets/images/icons/services/compliance/policy-training.svg";
import PrivacyPolicyDevelopment from "@/assets/images/icons/services/compliance/privacy-policy-development.svg";
import ProactiveRemediation from "@/assets/images/icons/services/compliance/proactive-remediation.svg";
import RealTimeMonitoring from "@/assets/images/icons/services/compliance/real-time-monitoring.svg";
import ReducingCosts from "@/assets/images/icons/services/compliance/reducing-costs.svg";
import RegularSimulations from "@/assets/images/icons/services/compliance/regular-simulations.svg";
import ReportingAndRemediation from "@/assets/images/icons/services/compliance/reporting-and-remediation.svg";
import RiskAssessmentIntegration from "@/assets/images/icons/services/compliance/risk-assessment-integration.svg";
import RiskPrioritization from "@/assets/images/icons/services/compliance/risk-prioritization.svg";
import RiskTreatmentPlan from "@/assets/images/icons/services/compliance/risk-treatment-plan.svg";
import ScenarioDevelopment from "@/assets/images/icons/services/compliance/scenario-development.svg";
import ScopeDetermination from "@/assets/images/icons/services/compliance/scope-determination.svg";
import SecureCodingTraining from "@/assets/images/icons/services/compliance/secure-coding-training.svg";
import SecurityAwareness from "@/assets/images/icons/services/compliance/security-awareness.svg";
import SingleSourceOfTruth from "@/assets/images/icons/services/compliance/single-source-of-truth.svg";
import Soc1 from "@/assets/images/icons/services/compliance/soc-1.svg";
import Soc2 from "@/assets/images/icons/services/compliance/soc-2.svg";
import Soc3 from "@/assets/images/icons/services/compliance/soc-3.svg";
import SocCybersecurity from "@/assets/images/icons/services/compliance/soc-cybersecurity.svg";
import StakeholderCollaboration from "@/assets/images/icons/services/compliance/stakeholder-collaboration.svg";
import StakeholderEngagement from "@/assets/images/icons/services/compliance/stakeholder-engagement.svg";
import StaticTools from "@/assets/images/icons/services/compliance/static-tools.svg";
import TailoredContent from "@/assets/images/icons/services/compliance/tailored-content.svg";
import TechIntegration from "@/assets/images/icons/services/compliance/tech-integration.svg";
import ThickClient from "@/assets/images/icons/services/compliance/thick-client.svg";
import ThoroughVetting from "@/assets/images/icons/services/compliance/thorough-vetting.svg";
import ThreatActorProfiling from "@/assets/images/icons/services/compliance/threat-actor-profiling.svg";
import UnifiedDataRepository from "@/assets/images/icons/services/compliance/unified-data-repository.svg";
import UserFriendlyInterfaces from "@/assets/images/icons/services/compliance/user-friendly-interfaces.svg";
import Vector from "@/assets/images/icons/services/compliance/vector.svg";
import VendorRiskManagementTprm from "@/assets/images/icons/services/compliance/vendor-risk-management-tprm.svg";

// Configuration Assessment
import ConfigurationAudit from "@/assets/images/icons/services/configuration-assessment/configuration-audit.svg";
import ConfigurationHardening from "@/assets/images/icons/services/configuration-assessment/configuration-hardening.svg";
import ConfigurationReview from "@/assets/images/icons/services/configuration-assessment/configuration-review.svg";
import DataCollection from "@/assets/images/icons/services/configuration-assessment/data-collection.svg";
import FirmwareAnalysis from "@/assets/images/icons/services/configuration-assessment/firmware-analysis.svg";
import PolicyAssessment from "@/assets/images/icons/services/configuration-assessment/policy-assessment.svg";
import SecurityAssessment from "@/assets/images/icons/services/configuration-assessment/security-assessment.svg";
import TestingAndValidation from "@/assets/images/icons/services/configuration-assessment/testing-and-validation.svg";

// Data Privacy
import AutomaticDataMasking from "@/assets/images/icons/services/data-privacy/automatic-data-masking.svg";
import ComplianceSolutions from "@/assets/images/icons/services/data-privacy/compliance-solutions.svg";
import ConnectToApps from "@/assets/images/icons/services/data-privacy/connect-to-apps.svg";
import ControlledUsage from "@/assets/images/icons/services/data-privacy/controlled-usage.svg";
import CrossBorderCompliance from "@/assets/images/icons/services/data-privacy/cross-border-compliance.svg";
import CustomPolicyDesign from "@/assets/images/icons/services/data-privacy/custom-policy-design.svg";
import DataCreationAndCapture from "@/assets/images/icons/services/data-privacy/data-creation-and-capture.svg";
import DataHandlingOptimization from "@/assets/images/icons/services/data-privacy/data-handling-optimization.svg";
import EnforceGuardrails from "@/assets/images/icons/services/data-privacy/enforce-guardrails.svg";
import EnforceLeastPrivilegedAccess from "@/assets/images/icons/services/data-privacy/enforce-least-privileged-access.svg";
import MaintainingPrivacyProgram from "@/assets/images/icons/services/data-privacy/maintaining-privacy-program.svg";
import PrivacyByDesign from "@/assets/images/icons/services/data-privacy/privacy-by-design.svg";
import RetentionCompliance from "@/assets/images/icons/services/data-privacy/retention-compliance.svg";
import SecureDisposal from "@/assets/images/icons/services/data-privacy/secure-disposal.svg";
import SecureStorage from "@/assets/images/icons/services/data-privacy/secure-storage.svg";
import StrategicArchival from "@/assets/images/icons/services/data-privacy/strategic-archival.svg";
import VendorPrivacyManagement from "@/assets/images/icons/services/data-privacy/vendor-privacy-management.svg";

// Managed Security Services
import ComplianceVerification from "@/assets/images/icons/services/managed-security-services/compliance-verification.svg";
import CriticalItResourcesAndApplications from "@/assets/images/icons/services/managed-security-services/critical-it-resources-and-applications.svg";
import DataInventory from "@/assets/images/icons/services/managed-security-services/data-inventory.svg";
import DataSubjectAccessRequests from "@/assets/images/icons/services/managed-security-services/data-subject-access-requests.svg";
import HumanRiskManagement from "@/assets/images/icons/services/managed-security-services/human-risk-management.svg";
import KeyCybersecurityStakeholders from "@/assets/images/icons/services/managed-security-services/key-cybersecurity-stakeholders.svg";

// Penetration Testing
import ActiveDirectory from "@/assets/images/icons/services/penetration-testing/active-directory.svg";
import ApplicationServers from "@/assets/images/icons/services/penetration-testing/application-servers.svg";
import AuthenticationServers from "@/assets/images/icons/services/penetration-testing/authentication-servers.svg";
import AutomatedAnalysis from "@/assets/images/icons/services/penetration-testing/automated-analysis.svg";
import AzureSqlDatabase from "@/assets/images/icons/services/penetration-testing/azure-sql-database.svg";
import AzureVirtualMachines from "@/assets/images/icons/services/penetration-testing/azure-virtual-machines.svg";
import BackupServers from "@/assets/images/icons/services/penetration-testing/backup-servers.svg";
import CloudFunctions from "@/assets/images/icons/services/penetration-testing/cloud-functions.svg";
import CloudStorage from "@/assets/images/icons/services/penetration-testing/cloud-storage.svg";
import ComputeEngine from "@/assets/images/icons/services/penetration-testing/compute-engine.svg";
import DatabaseServers from "@/assets/images/icons/services/penetration-testing/database-servers.svg";
import Ec2Instances from "@/assets/images/icons/services/penetration-testing/ec-2-instances.svg";
import ECommercePlatforms from "@/assets/images/icons/services/penetration-testing/e-commerce-platforms.svg";
import EhrApplication from "@/assets/images/icons/services/penetration-testing/ehr-application.svg";
import EmailServers from "@/assets/images/icons/services/penetration-testing/email-servers.svg";
import EnumeratingServices from "@/assets/images/icons/services/penetration-testing/enumerating-services.svg";
import ErpSystems from "@/assets/images/icons/services/penetration-testing/erp-systems.svg";
import Exploitation from "@/assets/images/icons/services/penetration-testing/exploitation.svg";
import FileServers from "@/assets/images/icons/services/penetration-testing/file-servers.svg";
import FileSystems from "@/assets/images/icons/services/penetration-testing/file-systems.svg";
import FunctionalTesting from "@/assets/images/icons/services/penetration-testing/functional-testing.svg";
import HelpdeskSystems from "@/assets/images/icons/services/penetration-testing/helpdesk-systems.svg";
import Hrms from "@/assets/images/icons/services/penetration-testing/hrms.svg";
import InitialConsultation from "@/assets/images/icons/services/penetration-testing/initial-consultation.svg";
import NewInsurance from "@/assets/images/icons/services/penetration-testing/insurance.svg";
import LambdaFunctions from "@/assets/images/icons/services/penetration-testing/lambda-functions.svg";
import Logistics from "@/assets/images/icons/services/penetration-testing/logistics.svg";
import ManualReview from "@/assets/images/icons/services/penetration-testing/manual-review.svg";
import NetworkServices from "@/assets/images/icons/services/penetration-testing/network-services.svg";
import PaymentApps from "@/assets/images/icons/services/penetration-testing/payment-apps.svg";
import PlanningAndScoping from "@/assets/images/icons/services/penetration-testing/planning-and-scoping.svg";
import PostExploitation from "@/assets/images/icons/services/penetration-testing/post-exploitation.svg";
import Reconnaissance from "@/assets/images/icons/services/penetration-testing/reconnaissance.svg";
import RegistrySettingsWindows from "@/assets/images/icons/services/penetration-testing/registry-settings-windows.svg";
import RemediationSupport from "@/assets/images/icons/services/penetration-testing/remediation-support.svg";
import Revalidation from "@/assets/images/icons/services/penetration-testing/revalidation.svg";
import S3Buckets from "@/assets/images/icons/services/penetration-testing/s-3-buckets.svg";
import SmartOffices from "@/assets/images/icons/services/penetration-testing/smart-offices.svg";
import ThreatModeling from "@/assets/images/icons/services/penetration-testing/threat-modeling.svg";
import UnifiedCommunicationSystems from "@/assets/images/icons/services/penetration-testing/unified-communication-systems.svg";
import VulnerabilityAnalysis from "@/assets/images/icons/services/penetration-testing/vulnerability-analysis.svg";

// Security Assessment
import DataRecoveryTesting from "@/assets/images/icons/services/security-assesment/data-recovery-testing.svg";

// ----------------------------------------------------------------------------

export type IIconName = keyof typeof icons;

// An object that maps icon names to their corresponding SVGs
const icons = {
  assessment: Assessment.src,
  chevron_down: ChevronDown.src,
  chevron_right: ChevronRight.src,
  currency: Currency.src,
  database_encryption: DatabaseEncryption.src,
  dot: Dot.src,
  fintech: Fintech.src,
  government: Government.src,
  healthcare: Healthcare.src,
  manufacturing: Manufacturing.src,
  puzzle: Puzzle.src,
  li: Li.src,
  lock: Lock.src,
  old_mission: OldMission.src,
  right_arrow: RightArrow.src,
  rocket: Rocket.src,
  search_book: SearchBook.src,
  shield: Shield.src,
  target: Target.src,
  task_list: TaskList.src,
  pdf_file: PdfFile.src,
  text_file: TextFile.src,
  excel_sheet: ExcelSheet.src,
  flag: Flag.src,
  code_editor: CodeEditor.src,
  key: Key.src,
  community: Community.src,
  policies: Policies.src,
  hand_shake: HandShake.src,
  risk: Risk.src,
  add_folder: AddFolder.src,
  person: Person.src,
  mail_yellow: MailYellow.src,
  mail_blue: MailBlue.src,
  call_yellow: CallYellow.src,
  call_blue: CallBlue.src,
  clock: Clock.src,
  location: Location.src,
  target_cursor: TargetCursor.src,
  post_address: postAddress.src,
  work_inquiries: workInquiries.src,
  support: support.src,
  office_hours: officeHours.src,
  bug_virus: bugVirus.src,
  cloud: cloud.src,
  desktop_code: desktopCode.src,
  phone: phone.src,
  insurance: insurance.src,
  script: script.src,
  twitter: Twitter.src,
  linkedin: Linkedin.src,
  whatsapp: Whatsapp.src,
  teams: Teams.src,
  slack: Slack.src,
  gmail: Gmail.src,
  case_study_icon: CaseStudyIcon.src,
  excited: Excited.src,
  break: Break.src,
  communication: Communication.src,
  alarm: AlarmClock.src,
  documentation: Documentation.src,
  lab_access: LabAccess.src,
  quality_training: QualityTraining.src,
  training: Training.src,
  professional_trainers: ProfessionalTrainers.src,
  use_case: UseCase.src,
  sample_reports: SampleReports.src,
  e_book: EBook.src,
  data_sheet: DataSheet.src,
  safe_guard: insurance.src,
  law: script.src,
  compliance_and_privacy: ComplianceAndPrivacy.src,
  incident_response: IncidentRespose.src,
  mission: Mission.src,
  pentest_management: PentestManagement.src,
  values: Values.src,
  vision: Vision.src,
  client_champion: ClientChampion.src,
  energy_boosters: EnergyBoosters.src,
  lifelong_learners: LifelongLearners.src,
  mental_health_matters: MentalHealthMatters.src,
  monday_blues: MondayBlues.src,
  take_breaks: TakeBreaks.src,
  talk_in_out: TalkItOut.src,
  ai_security: AiSecurity.src,
  compliance: Compliance.src,
  effective_security_controls: EffectiveSecurityControls.src,
  increased_vigilance: IncreasedVigilance.src,
  managed_services: ManagedServices.src,
  privacy_assessment: PrivacyAssessment.src,
  proactive_approach: ProactiveApproach.src,
  saas: Saas.src,
  vulnerability_management: VulnerabilityManagement.src,
  apis: Apis.src,
  customer_data: CustomerData.src,
  financial_transactions: FinancialTransactions.src,
  payment_systems: PaymentSystems.src,
  applications: Applications.src,
  billing_systems: BillingSystems.src,
  ehr_systems: EhrSystems.src,
  medical_devices: MedicalDevices.src,
  vendor_selection: VendorSelection.src,
  industrial_control_systems: IndustrialControlSystems.src,
  iot_devices: IotDevices.src,
  production_data: ProductionData.src,
  supply_chain: SupplyChain.src,
  application_integrity: ApplicationIntegrity.src,
  regulatory_compliance: RegulatoryCompliance.src,
  asset_management_company: AssetManagementCompany.src,
  domestic_logistics_firm: DomesticLogisticFirm.src,
  e_commerce_platform: ECommercePlatform.src,
  fintech_banking_firm: FintechBankingFirm.src,
  healthcare_firms_erp_software: HealthcareFirmsErpSoftware.src,
  logistic_shipping_company: LogisticShippingCompany.src,
  machinery_manufacturing_firm: MachineryManufacturingFirm.src,
  pharma_manufacturing_firm: PharmaManufacturingFirm.src,
  saas_product: SaasProduct.src,
  adversial_attack_simulation: AdversarialAttackSimulation.src,
  continuous_monitoring: ContinuesMonitoring.src,
  data_governance: DataGovernance.src,
  data_integrity_testing: DataIntegrityTesting.src,
  model_integrity_audits: ModelIntegrityAudits.src,
  model_robustness_evaluation: ModelRobustnessEvaluation.src,
  adaptive_security_measures: AdaptiveSecurityMeasures.src,
  advanced_persistent_threat: AdvancedPersistentThreat.src,
  advanced_search_algorithms: AdvancedSearchAlgorithms.src,
  advanced_threat_detection: AdvancedThreatDetection.src,
  applicability: Applicability.src,
  assessment_and_feedback: AssessmentAndFeedback.src,
  attack_surface_mapping: AttackSurfaceMapping.src,
  audit_and_reporting: AuditAndReporting.src,
  audit_readiness_and_support: AuditReadinessAndSupport.src,
  automated_and_manual_assessments: AutomatedAndManualAssessments.src,
  automated_and_manual_assessments_firm: AutomatedAndManualAssessmentsFirm.src,
  automated_audit_trails: AutomatedAuditTrails.src,
  baseline_establishment: BaselineEstablishment.src,
  business_continuity_and_disaster_recovery:
    BusinessContinuityAndDisasterRecovery.src,
  centralized_management: CentralizedManagement.src,
  cloud_infrastructure_security: CloudInfrastructureSecurity.src,
  cohesive_search_and_discover: CohesiveSearchAndDiscover.src,
  compliance_mapping: ComplianceMapping.src,
  compliance_updates: ComplianceUpdates.src,
  configuration_and_deployment: ConfigurationAndDeployment.src,
  consent_capture_and_store: ConsentCaptureAndStore.src,
  credential_monitoring: CredentialMonitoring.src,
  cross_functional_coordination: CrossFunctionalCoordination.src,
  customized_iam_plan: CustomizedIamPlan.src,
  customized_training_plan: CustomizedTrainingPlan.src,
  custom_policy_drafting: CustomPolicyDrafting.src,
  data_audits: DataAudits.src,
  data_deletion_and_retention: DataDeletionAndRetention.src,
  data_encryption_and_secure_communication:
    DataEncryptionAndSecureCommunication.src,
  data_flow_mapping: DataFlowMapping.src,
  data_insights: DataInsights.src,
  data_leak_detection: DataLeakDetection.src,
  data_privacy_implementation: DataPrivacyImplementation.src,
  data_protection_impact_assessment: DataProtectionImpactAssessment.src,
  define_scope_and_objectives: DefineScopeAndObjectives.src,
  drill_execution: DrillExecution.src,
  dynamic_updates: DynamicUpdates.src,
  enforce_access_controls: EnforceAccessControls.src,
  enhanced_security: EnhancedSecurity.src,
  external_penetration_testing: ExternalPenetrationTesting.src,
  extract_lineage_information: ExtractLineageInformation.src,
  firewall_and_router_configuration_audit:
    FirewallAndRouterConfigurationAudit.src,
  framework_optimization: FrameworkOptimization.src,
  gap_assessment: GapAssessment.src,
  gdpr: Gdpr.src,
  hippa: Hippa.src,
  identify_user_access: IdentifyUserAccess.src,
  improved_user_experience: ImprovedUserExperience.src,
  initial_assessment: InitialAssessment.src,
  initial_vendor_assessment: InitialVendorAssessment.src,
  integration_of_dark_web_monitoring: IntegrationOfDarkWebMonitoring.src,
  integration_with_cloud_security_solution:
    IntegrationWithCloudSecuritySolution.src,
  integration_with_email_security_solution:
    IntegrationWithEmailSecuritySolution.src,
  interactive_engagement: InteractiveEngagement.src,
  internal_vulnerability_assessment: InternalVulnerabilityAssessment.src,
  iso_27799: Iso27799.src,
  mitigate_privacy_risk: MitigatePrivacyRisk.src,
  mobile_application: MobileApplication.src,
  monitor_access_changes: MonitorAccessChanges.src,
  multi_jurisdictional_expertise: MultiJurisdictionalExpertise.src,
  multi_platform_acquisition: MultiPlatformAcquisition.src,
  ongoing_management: OngoingManagement.src,
  ongoing_review: OngoingReview.src,
  patch_management: PatchManagement.src,
  pci: Pci.src,
  pci_dss_compliance_reporting: PciDssComplianceReporting.src,
  phishing_simulation: PhishingSimulation.src,
  playbook_development: PlaybookDevelopment.src,
  policy_and_procedure_review: PolicyAndProcedureReview.src,
  policy_design: PolicyDesign.src,
  policy_development: PolicyDevelopment.src,
  policy_training: PolicyTraining.src,
  privacy_policy_development: PrivacyPolicyDevelopment.src,
  proactive_remediation: ProactiveRemediation.src,
  real_time_monitoring: RealTimeMonitoring.src,
  reducing_costs: ReducingCosts.src,
  regular_simulations: RegularSimulations.src,
  reporting_and_remediation: ReportingAndRemediation.src,
  risk_assessment_integration: RiskAssessmentIntegration.src,
  risk_prioritization: RiskPrioritization.src,
  risk_treatment_plan: RiskTreatmentPlan.src,
  scenario_development: ScenarioDevelopment.src,
  scope_determination: ScopeDetermination.src,
  secure_coding_training: SecureCodingTraining.src,
  security_awareness: SecurityAwareness.src,
  single_source_of_truth: SingleSourceOfTruth.src,
  soc_1: Soc1.src,
  soc_2: Soc2.src,
  soc_3: Soc3.src,
  soc_cybersecurity: SocCybersecurity.src,
  stakeholder_collaboration: StakeholderCollaboration.src,
  stakeholder_engagement: StakeholderEngagement.src,
  static_tools: StaticTools.src,
  tailored_content: TailoredContent.src,
  tech_integration: TechIntegration.src,
  thick_client: ThickClient.src,
  thorough_vetting: ThoroughVetting.src,
  threat_actor_profiling: ThreatActorProfiling.src,
  unified_data_repository: UnifiedDataRepository.src,
  user_friendly_interfaces: UserFriendlyInterfaces.src,
  vector: Vector.src,
  vendor_risk_management_tprm: VendorRiskManagementTprm.src,
  configuration_audit: ConfigurationAudit.src,
  configuration_hardening: ConfigurationHardening.src,
  configuration_review: ConfigurationReview.src,
  data_collection: DataCollection.src,
  firmware_analysis: FirmwareAnalysis.src,
  policy_assessment: PolicyAssessment.src,
  security_assessment: SecurityAssessment.src,
  testing_and_validation: TestingAndValidation.src,
  automatic_data_masking: AutomaticDataMasking.src,
  compliance_solutions: ComplianceSolutions.src,
  connect_to_apps: ConnectToApps.src,
  controlled_usage: ControlledUsage.src,
  cross_border_compliance: CrossBorderCompliance.src,
  custom_policy_design: CustomPolicyDesign.src,
  data_creation_and_capture: DataCreationAndCapture.src,
  data_handling_optimization: DataHandlingOptimization.src,
  enforce_guardrails: EnforceGuardrails.src,
  enforce_least_privileged_access: EnforceLeastPrivilegedAccess.src,
  maintaining_privacy_program: MaintainingPrivacyProgram.src,
  privacy_by_design: PrivacyByDesign.src,
  retention_compliance: RetentionCompliance.src,
  secure_disposal: SecureDisposal.src,
  secure_storage: SecureStorage.src,
  strategic_archival: StrategicArchival.src,
  vendor_privacy_management: VendorPrivacyManagement.src,
  compliance_verification: ComplianceVerification.src,
  critical_it_resources_and_applications:
    CriticalItResourcesAndApplications.src,
  data_inventory: DataInventory.src,
  data_subject_access_requests: DataSubjectAccessRequests.src,
  human_risk_management: HumanRiskManagement.src,
  key_cybersecurity_stakeholders: KeyCybersecurityStakeholders.src,
  active_directory: ActiveDirectory.src,
  application_servers: ApplicationServers.src,
  authentication_servers: AuthenticationServers.src,
  automated_analysis: AutomatedAnalysis.src,
  azure_sql_database: AzureSqlDatabase.src,
  azure_virtual_machines: AzureVirtualMachines.src,
  backup_servers: BackupServers.src,
  cloud_functions: CloudFunctions.src,
  cloud_storage: CloudStorage.src,
  compute_engine: ComputeEngine.src,
  database_servers: DatabaseServers.src,
  ec2_instances: Ec2Instances.src,
  e_commerce_platforms: ECommercePlatforms.src,
  ehr_application: EhrApplication.src,
  email_servers: EmailServers.src,
  enumerating_services: EnumeratingServices.src,
  erp_systems: ErpSystems.src,
  exploitation: Exploitation.src,
  file_servers: FileServers.src,
  file_systems: FileSystems.src,
  functional_testing: FunctionalTesting.src,
  helpdesk_systems: HelpdeskSystems.src,
  hrms: Hrms.src,
  initial_consultation: InitialConsultation.src,
  new_insurance: NewInsurance.src,
  lambda_functions: LambdaFunctions.src,
  logistics: Logistics.src,
  manual_review: ManualReview.src,
  network_services: NetworkServices.src,
  payment_apps: PaymentApps.src,
  planning_and_scoping: PlanningAndScoping.src,
  post_exploitation: PostExploitation.src,
  reconnaissance: Reconnaissance.src,
  registry_settings_windows: RegistrySettingsWindows.src,
  remediation_support: RemediationSupport.src,
  revalidation: Revalidation.src,
  s3_buckets: S3Buckets.src,
  smart_offices: SmartOffices.src,
  threat_modeling: ThreatModeling.src,
  unified_communication_systems: UnifiedCommunicationSystems.src,
  vulnerability_analysis: VulnerabilityAnalysis.src,
  data_recovery_testing: DataRecoveryTesting.src,
};

// Function to get the icon source
const icon = (iconName: IIconName): string => {
  return icons[iconName];
};

export default icon;
